import React from 'react';
import { SimpleShowLayout } from 'react-admin';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';

const styles = ({ spacing, typography }) => ({
  root: {
    maxWidth: '200px',
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    border: '1px solid #e0e0e0',
    borderRadius: '4px',
    padding: `${spacing.unit * 1.5}px ${spacing.unit * 2}px ${spacing.unit * 1.5}px ${spacing.unit * 1.5}px`,
    marginBottom: spacing.unit * 2,
    boxSizing: 'border-box',
    flexShrink: 0,
  },
  title: {
    fontSize: 'medium',
    fontFamily: typography.fontFamily,
    marginBottom: spacing.unit,
    width: '100%',
  },
  field: {
    float: 'left',
    height: '90px',
    width: '100%',
  },
  fieldContent: {
    width: '100%',
    marginRight: '0',
  },
});

const GroupedFields = ({ classes, fields = [], title, className, resource, record }) => (
  <SimpleShowLayout className={`${classes.root} ${className || ''}`} resource={resource} record={record}>
    {title && (
      <Typography variant="subheading" className={classes.title}>
        {title}
      </Typography>
    )}
    {fields.map(field => field)}
  </SimpleShowLayout>
);

GroupedFields.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string,
    title: PropTypes.string,
    field: PropTypes.string,
    fieldContent: PropTypes.string,
  }),
  fields: PropTypes.arrayOf(PropTypes.element),
  title: PropTypes.string,
  className: PropTypes.string,
  resource: PropTypes.string,
  record: PropTypes.shape({}),
};

export default withStyles(styles)(GroupedFields);
